var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vue-listing"},[_c('div',{staticClass:"vue-listing__head"},[_c('SvgIcon',{staticClass:"vue-listing__icon",attrs:{"iconName":"ico-dog"}}),(_vm.title)?_c('h3',{staticClass:"vue-listing__title"},[_vm._v(_vm._s(_vm.title))]):_vm._e()],1),(_vm.pagesData)?_c('PartIconList',{attrs:{"items":_vm.pagesData}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }